var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2419 18.1429C23.2419 20.8996 20.9986 23.1429 18.2419 23.1429C15.4852 23.1429 13.2419 20.8996 13.2419 18.1429C13.2419 15.3862 15.4852 13.1429 18.2419 13.1429C20.9986 13.1429 23.2419 15.3862 23.2419 18.1429ZM28.9562 27.4286C28.9562 27.0491 28.7999 26.6808 28.5432 26.4241L24.7151 22.596C25.6191 21.2902 26.0991 19.7277 26.0991 18.1429C26.0991 13.8013 22.5834 10.2857 18.2419 10.2857C13.9004 10.2857 10.3848 13.8013 10.3848 18.1429C10.3848 22.4844 13.9004 26 18.2419 26C19.8267 26 21.3892 25.5201 22.695 24.6161L26.5232 28.433C26.7799 28.7009 27.1482 28.8571 27.5276 28.8571C28.3089 28.8571 28.9562 28.2098 28.9562 27.4286Z",
    fill: "#E1541B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.1a1051893dc84ef0ee504be8cc84a27f.svg";
export { ForwardRef as ReactComponent };